<template>
  <div>
    <div v-for="(item, index) in items" :key="index" class="mb-4">
      <icd-range
        :search="item"
        @aliases="addAliases($event)"
        :isCollection="true"
      ></icd-range>
      <!-- <div v-else><icd-details :code="item"></icd-details></div> -->
    </div>
    <see-also
      v-if="collection && !$vuetify.breakpoint.smAndUp"
      :identifier="collection"
      identifier_type="ICD10"
      referrer="ICD10"
      class="my-2"
    ></see-also>
  </div>
</template>

<script>
export default {
  components: {
    IcdRange: () => import("@/components/icdStuff/IcdRange"),
    SeeAlso: () => import("@/components/universalStuff/SeeAlso.vue"),

    // IcdDetails: () => import("@/components/icdStuff/IcdDetails"),
  },
  name: "IcdCollection",
  props: {
    collection: null,
  },
  data: function () {
    return {
      allAliases: null,
    };
  },
  methods: {
    addAliases(arr) {
      if (!arr || !arr.length) return;
      if (!this.allAliases) {
        this.allAliases = arr;
      } else {
        this.allAliases = [...this.allAliases, ...arr];
      }
    },
  },
  computed: {
    items: function () {
      if (!this.collection) return null;
      return this.collection.split(",");
    },
  },
  watch: {
    allAliases(val) {
      this.$emit("aliases", val);
    },
  },
};
</script>

<style scoped></style>
